module.exports = __webpack_public_path__ + "img/TS6202-309.ff8fdd47.jpg";